<template>
    <paper class="dispatchOrderDetail">
        <div class="dispatch-info-header">
            <i class="el-icon-back" @click="backToIndex"></i>
            <span class="info-header-content" @dblclick.self="dblclickCopy()"><strong>发车单号:</strong>
                {{ dispatchNo }}<i class="el-icon-document-copy" @click.stop="copyDispatchNo()"></i>
            </span>
            <span class="info-header-content"><strong>发车单状态：</strong><span class="info-header-active">{{basicInfo.dispatchStatusName}}</span></span>
            <span><strong>创建人：</strong>{{basicInfo.createUserName}}</span>
            <el-button type="primary" class="button-print" @click="print" :loading="loading">打印</el-button>
            <el-button class="button-update" @click="update" :loading="btnLoading">刷新</el-button>
        </div>
        <!-- 链路信息 -->
        <link-information :linkInfo="linkInfo" :dictData="dictData" :componentsData="{ dispatchNo }"></link-information>
        <!-- 基础信息 -->
        <basic-information :dispatchNo="dispatchNo" :basicInfo="basicInfo" :dictData="dictData"></basic-information>
        <!-- 站点信息 -->
        <site-information :loadList="loadList" :unloadList="unloadList" :basicInfo="basicInfo"></site-information>
        <appointment-information :loadBookList="loadBookList"></appointment-information>
        <!-- 任务信息 -->
        <task-information
            ref="taskInformation"
            :taskInfo="taskInfo"
            :goodsInfo="goodsInfo"
            :taskTotal="taskTotal"
            :basicInfo="basicInfo"
            :btnLoading="btnLoading"
            :pageLoading="pageLoading"
            @handleBatchSearch="handleBatchSearch"
        ></task-information>
        <!-- 费用信息 -->
        <expenses-information :basicInfo="basicInfo"></expenses-information>
        <!-- 里程信息 -->
        <mileage-information :basicInfo="basicInfo" :mileageDetailData="mileageDetailData" :calculationType="calculationType"></mileage-information>
        <!-- 新版打印窗口 -->
        <dispatch-new-print
            v-if="isShowNewPrintDialog"
            ref="dispatchNewPrint"
            :isShowNewPrintDialog.sync="isShowNewPrintDialog"
            :printConfig="printList"
            :dictData="dictData"
            :componentsData="componentsData"
            :professionalCompanyConfig="professionalCompanyConfig"
            @openOldPrintDialog="openOldPrintDialog"
            ></dispatch-new-print>

        <!-- 旧版打印窗口 -->
        <dispatch-print
            v-if="isShowOldPrintDialog"
            ref="dispatchPrint"
            :isShowOldPrintDialog.sync="isShowOldPrintDialog"
            :componentsData="componentsData[0]"
            :dictData="dictData"
            :professionalCompanyConfig="professionalCompanyConfig"
            @components-close="closeDialog"
            ></dispatch-print>

        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleCloseTip">
            <span>
                <i class="el-icon-warning-outline timeoutTip"></i>
                等待太久？您可以点击下方按钮，直接访问老版打印窗口。若继续等待，请不要退出界面，系统仍在匹配模板中，系统会根据匹配结果展示对应打印窗口。
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseTip">不打印了</el-button>
                <el-button type="primary" @click="openOldPrintDialog">跳转到老版打印界面</el-button>
            </span>
        </el-dialog>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import LinkInformation from './components/LinkInformation';
import BasicInformation from './components/BasicInformation';
import SiteInformation from './components/SiteInformation';
import TaskInformation from './components/TaskInformation';
import ExpensesInformation from './components/ExpensesInformation';
import MileageInformation from './components/MileageInformation';
import AppointmentInformation from './components/AppointmentInformation';
// 新打印弹窗
import DispatchNewPrint from '../components/dispatchNewPrint/Index';
// 旧打印弹窗
import DispatchPrint from '../components/dispatchPrint/Index';
import { batchQueryTemplate, queryCompanyConfig  } from '@/modules/transport/otp/api/performanceDispatchNewPrint.js';
import { copyToClip, formatBasicInfoList, formatLoadBookList, formatLoadList, formatUnloadList, formatTaskList, formatGoodsList, formatDetailList } from './util.js';
import { queryDispatchStatusRoute, queryDispatchBasicInfo, queryDispatchTransports, queryDispatchTaskList, queryItemList, queryLichengRecord } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import { dictWithUrl } from '@/components/lots/api.js';
import bigDataLog from '@/utils/bigDataLog';
export default {
    name: 'PerformanceDispatchInfo',
    components: {
        paper,
        LinkInformation,
        BasicInformation,
        SiteInformation,
        AppointmentInformation,
        TaskInformation,
        ExpensesInformation,
        MileageInformation,
        DispatchNewPrint,
        DispatchPrint
    },
    data () {
        return {
            dialogVisible: false,
            suspend: false,
            loading: false,
            timeout: false,
            btnLoading: false,
            pageLoading: false,
            dictData: {}, // 数据字典集合
            dispatchNo: '',
            linkInfo: [], // 链路信息
            basicInfo: {}, // 基础信息
            loadList: [], // 装货站点
            unloadList: [], // 卸货站点
            taskInfo: [], // 任务信息-运单维度
            goodsInfo: [], // 任务信息-商品维度
            inOutType: '',
            mileageDetailData: [], // 里程明细
            calculationType: 0, // 里程计算方式
            isShowNewPrintDialog: false,
            isShowOldPrintDialog: false,
            componentsData: [],
            taskTotal: 0,
            loadBookList: [],
            professionalCompanyConfig: {}
        };
    },
    async mounted () {
        this.dispatchNo = this.$route.query.dispatchNo;
        this.queryDispatchStatusRoute();
        await this.getDicData();
        this.queryDispatchBasicInfo();
        this.queryDispatchTransports();
        this.queryDispatchTaskList();
        this.queryItemList();
        this.queryLichengRecord();
        this.queryCompanyConfig();
    },
    activated () {
        if (this.$route.query.dispatchNo !== this.dispatchNo) {
            this.dispatchNo = this.$route.query.dispatchNo;
            this.update();
        }
    },
    computed: {
        dataPowerFlag: function () { // 运输收入，毛利率，毛利金额 三个字段的数据权限，由按钮权限控制
            const flag = this.$_has('/performance/dispatch-order/label'); // /performance/dispatch-order/label 对应 数据权限 按钮权限的编码
            return flag;
        }
    },
    methods: {
        // 获取打印专司卡控配置
        queryCompanyConfig () {
            queryCompanyConfig().then(res => {
                if (res && +res.code === 0) {
                    this.professionalCompanyConfig = res.data || {};
                }
            }).catch(() => { });
        },
        /**
         * @description 返回发车单管理页面
         */
        backToIndex () {
            this.$router.push({
                path: `/performance/dispatch-order`
            });
        },
        /**
         * @description 点击按钮复制发车单号到粘贴板
         */
        copyDispatchNo () {
            copyToClip(this.dispatchNo);
        },
        dblclickCopy () {
            copyToClip(this.dispatchNo);
        },
        print () {
            bigDataLog.sendDetailMessageByKey('bigData-btn-print');
            this.componentsData = [{ dispatchNo: this.dispatchNo, professionalCompany: this.basicInfo.professionalCompany }];
            this.timeout = false;
            this.loading = true;
            const timer = setTimeout(() => {
                this.dialogVisible = true;
                this.timeout = true;
            }, 7000);
            batchQueryTemplate({ dispatchNoList: [this.dispatchNo] }).then(res => {
                clearTimeout(timer);
                if (res && +res.code === 0 && !this.suspend) {
                    if (!res.data) {
                        this.isShowOldPrintDialog = true;
                    } else {
                        this.printList = res.data || [];
                        this.isShowNewPrintDialog = true;
                    }
                } else {
                    this.isShowOldPrintDialog = true;
                }
            })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                    this.dialogVisible = false;
                });
        },
        handlePrint (data, repeatPrintReason) {

        },
        openOldPrintDialog (componentsData) {
            this.$nextTick(() => {
                this.componentsData = [componentsData];
                this.isShowOldPrintDialog = true;
            });
        },
        handleCloseTip () {
            this.suspend = true;
            this.loading = false;
            this.dialogVisible = false;
        },
        closeDialog () {
            this.isShowOldPrintDialog = false;
        },
        /**
         * @description 刷新发车单管理明细页面
         */
        update() {
            this.btnLoading = true;
            Promise.all([
                this.queryDispatchStatusRoute(),
                this.queryDispatchBasicInfo(),
                this.queryDispatchTransports(),
                this.queryLichengRecord()
            ]).then(() => {
                this.btnLoading = false;
                this.$refs.taskInformation.radio = '商品维度';
                this.queryDispatchTaskList();
                this.queryItemList();
            });
        },
        handleBatchSearch (goodsParams, orderParams) {
            this.pageLoading = true;
            Promise.all([
                this.queryItemList(goodsParams),
                this.queryDispatchTaskList(orderParams)
            ]).then(() => {
                this.pageLoading = false;
            });
        },
        /**
         * @description 查询链路信息
         */
        queryDispatchStatusRoute () {
            return queryDispatchStatusRoute(this.dispatchNo).then(res => {
                if (res && +res.code === 0) {
                    this.linkInfo = res.data.list || [];
                }
            });
        },
        /**
         * @description 查询基础信息
         */
        queryDispatchBasicInfo () {
            return queryDispatchBasicInfo(this.dispatchNo).then(res => {
                if (res && +res.code === 0) {
                    this.basicInfo = formatBasicInfoList(res.data || {}, this.dictData);
                    this.loadBookList = formatLoadBookList(res.data.loadBookList || []);
                    this.inOutType = this.basicInfo.inOutType || '';
                }
                if (!this.dataPowerFlag && this.basicInfo.transportationIncome) {
                    this.basicInfo.transportationIncome = '***';
                }
            });
        },
        /**
         * @description 查询站点信息
         */
        queryDispatchTransports () {
            return queryDispatchTransports(this.dispatchNo).then(res => {
                if (res && +res.code === 0) {
                    this.loadList = formatLoadList(res.data.loadList || [], this.dictData, this.inOutType);
                    this.unloadList = formatUnloadList(res.data.unloadList || [], this.dictData);
                }
            });
        },
        /**
         * @description 查询任务信息
         */
        queryDispatchTaskList (data) {
            const params = data ? { ...data } : { dispatchNo: this.dispatchNo };
            return queryDispatchTaskList(params).then(res => {
                if (res && +res.code === 0) {
                    this.taskInfo = formatTaskList(res.data || [], this.dictData);
                }
            });
        },
        /**
         * @description 查询任务信息
         */
        queryItemList (data) {
            const params = data ? { ...data } : { dispatchNo: this.dispatchNo };
            return queryItemList(params).then(res => {
                if (res && +res.code === 0) {
                    this.goodsInfo = formatGoodsList(res.data || [], this.dictData);
                }
            });
        },
        /**
         * @description 查询里程明细
         */
        queryLichengRecord () {
            return queryLichengRecord(this.dispatchNo).then(res => {
                if (res && +res.code === 0) {
                    this.calculationType = res.data.liChengType || 3; // 默认非串点不显示里程明细
                    this.mileageDetailData = formatDetailList(res.data.lichengRecordHeaderDtos || []);
                }
            });
        },
        /**
         * @description 获取数据字典
         * 发车单状态: DISPATCH_STATUS
         * 采购渠道：OTP_TMS_PROCUREMENT_CHANNEL
         * 合同外场景：TMS_CONTRACT_SITUATION
         * 整车零担标识：TMS_SHIPPING_TYPE
         * 预付方式：SYS_TMS_PAY_METHOD
         * 抵达方式：ARRIVER_WAY
         * 到车方式：PICK_UP_TYPE
         * 运单状态：TRANSPORT_STATUS
         * 配送方式：DELIVERY_TYPE
         * 计费业务类型: BUSINESS_TYPE
         * 是否分拨：DISTRIBUTION_FLAG
         * WMS状态：WMS_STATUS
         * 订单类型：ORDER_TYPE
         * 提货状态：PICK_UP_STATUS
         * 长合车计费新：MILEAGE_BILLING_TYPE
         * 发车单调整-计费车型-要求提示: BILLING_VEHICLE_TYPE_REQUIREMENT
         */
        async getDicData () {
            const dict = await dictWithUrl(
                // eslint-disable-next-line max-len
                'DISPATCH_STATUS,OTP_TMS_PROCUREMENT_CHANNEL,TMS_CONTRACT_SITUATION,TMS_SHIPPING_TYPE,SYS_TMS_PAY_METHOD,ARRIVER_WAY,PICK_UP_TYPE,TRANSPORT_STATUS,DELIVERY_TYPE,BUSINESS_TYPE,DISTRIBUTION_FLAG,WMS_STATUS,ORDER_TYPE,PICK_UP_STATUS,DISPATCH_WAY,CHC_BILLING_REMARK,MILEAGE_BILLING_TYPE,BILLING_RANKS_FLAG,DRIVER_PRINT_STATUS,SELF_PRINT_TEMPLATE,PRINT_TEMPLATE_STYLE_ATTRIBUTE,DISPATCH_EMERGENCE_FLAG,TMS_LOADING_METHOD,TASK_TYPE,BUSINESS_MODE,EC_TRANSPORT_TYPE,NO_CAR_CARRIER_TYPE,DEVICETYPE,NEW_TMS_LOAD_TYPE,EXCEPTION_TYPE,NEW_TMS_IFLOW_STATUS,TP_DISPATCH_STATUS,TP_DOCUMENTS_WAY,LCL_STATUS,OTP_IN_OUT_TYPE,SHIPPING_SCENE_TYPE,NOT_ISSUING_REASON,DISPATCH_ABNORMAL_REASON,TMS_DISPATCH_TYPE,O_ITEM_STATUS,NEW_PRINTF_TIP_TEXT,NEW_PRINTF_TIP_URL,TMS_OPERATION_NODE,OPERATION_LOG_ATTACHMENT_TYPE,BILLING_VEHICLE_TYPE_REQUIREMENT'
            );
            this.dictData = dict.data;
        }
    }
};
</script>

<style lang="less" scoped>
@import './dispatchInfoDetail.less';
</style>
